var exports = {
  "kL": "x61f99309--58f1b4--container",
  "UJ": "x61f99309--58f1b4--content-container",
  "Qs": "x61f99309--58f1b4--content",
  "II": "x61f99309--58f1b4--content-replay",
  "G0": "x61f99309--58f1b4--container-replay",
  "ZL": "x61f99309--58f1b4--replay-block",
  "KI": "x61f99309--58f1b4--replay-separate",
  "pq": "x61f99309--58f1b4--info",
  "x9": "x61f99309--58f1b4--container-short",
  "tH": "x61f99309--58f1b4--container-only-text",
  "Rj": "x61f99309--58f1b4--reload-button",
  "q9": "x61f99309--58f1b4--price",
  "ln": "x61f99309--58f1b4--formatted_old_price",
  "rW": "x61f99309--58f1b4--formatted_old_price_outcoming",
  "K4": "x61f99309--58f1b4--text_block",
};

module.exports = exports;
